// extracted by mini-css-extract-plugin
module.exports = {"commentContainer":"comment-section_commentContainer__Y_YX_","commentList":"comment-section_commentList__R0JSt"};